import * as actions from './actions'

import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import coach from './modules/coach'
import config from './modules/config'
import createLogger from '../plugins/logger'
import event from './modules/event'
import exterior from './modules/exterior'
import notification from './modules/notification'
import panorama from './modules/panorama'
import slide from './modules/slide'
import user from './modules/user'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'
const debug = false

export default new Vuex.Store({
  actions,
  modules: {
    config,
    auth,
    notification,
    event,
    coach,
    panorama,
    exterior,
    slide,
    user
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js